import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { courseLessons } from '../data/awsCloudFundamentalsLessons';
import './AWSCloudFundamentalsCourse.css';

const AWSCloudFundamentalsCourse: React.FC = () => {
  const [active, setActive] = useState(1);
  const lesson = courseLessons.find((l) => l.id === active)!;

  const go = (id: number) => {
    setActive(id);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Layout>
      <div className="page-hero">
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 6%' }}>
          <div style={{ fontSize: '0.9rem', color: 'var(--gray-600)', marginBottom: '12px' }}>
            <Link to="/programs" style={{ color: 'var(--blue)' }}>Programs</Link> /{' '}
            <Link to="/aws-ccp" style={{ color: 'var(--blue)' }}>AWS Cloud Practitioner</Link> / Fundamentals
          </div>
          <h1>AWS Cloud Fundamentals: Learn It Like a Story</h1>
          <p>No technical background needed. Your trainer walks you through AWS one idea at a time, using one story: Arjun building <b>QuickBite</b>, a local food-delivery app. Each lesson adds one piece to his system, so you see why every service exists, not just its name.</p>
          <div style={{ marginTop: '16px', display: 'flex', gap: '8px', flexWrap: 'wrap', justifyContent: 'center' }}>
            <span className="section-tag">Beginner</span>
            <span className="section-tag">10 lessons</span>
            <span className="section-tag orange">No tools or account needed</span>
          </div>
        </div>
      </div>

      <div className="cf-nav">
        <div className="cf-nav-inner">
          {courseLessons.map((l) => (
            <button key={l.id} className={`cf-tab${l.id === active ? ' on' : ''}`} onClick={() => go(l.id)}>
              {l.icon} Lesson {l.id}
            </button>
          ))}
        </div>
      </div>

      <div className="cf section" style={{ paddingTop: '20px' }}>
        <div className="cf-body">
          <svg width="0" height="0" style={{ position: 'absolute' }}>
            <defs>
              <marker id="h" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
                <path d="M0,0 L8,4 L0,8z" fill="#5f6881" />
              </marker>
            </defs>
          </svg>

          <section className="les ck">
            <div className="sh">
              <i>{lesson.icon}</i>
              <div>
                <h2>Lesson {lesson.id}: {lesson.title}</h2>
                <small>{lesson.subtitle}</small>
              </div>
            </div>
            <div key={lesson.id} dangerouslySetInnerHTML={{ __html: lesson.html }} />
          </section>

          <div className="cf-pager">
            <button className="btn btn-outline-blue" disabled={active === 1} style={{ opacity: active === 1 ? 0.5 : 1 }} onClick={() => go(active - 1)}>← Previous</button>
            <span style={{ fontWeight: 700, color: 'var(--gray-600)' }}>Lesson {active} of {courseLessons.length}</span>
            <button className="btn btn-blue" disabled={active === courseLessons.length} style={{ opacity: active === courseLessons.length ? 0.5 : 1 }} onClick={() => go(active + 1)}>Next →</button>
          </div>

          {active === courseLessons.length && (
            <div className="cf-end">
              <h2>Course complete</h2>
              <p>You have followed QuickBite from one server to a secure, scalable, monitored system. Keep going: pick a topic and explain it to someone else.</p>
              <div style={{ marginTop: '14px' }}>
                <Link to="/aws-ccp" className="btn btn-orange">Back to Learning Hub</Link>
              </div>
            </div>
          )}

          <h3 style={{ margin: '36px 0 14px', color: 'var(--gray-800)' }}>Course map</h3>
          <div className="cf-map">
            {courseLessons.map((l) => (
              <button key={l.id} onClick={() => go(l.id)}>
                <b>{l.icon} Lesson {l.id}</b>
                {l.title}
              </button>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AWSCloudFundamentalsCourse;
